<template>
  <div class="assistente-consulta">

    <Panel lineColor="var(--primary-color)" class="assistente-panel" id="card-filtros-consulta">
      <p class="nota-informativa">
        <v-icon size="14" color="primario">fas fa-info-circle</v-icon>
        Lista os itens de pedidos confirmados que entraram pelo assistente.
        Período em branco busca tudo, página a página.
      </p>

      <div class="section-header">
        <div>
          <h3 class="section-title">Filtros</h3>
        </div>
      </div>
      <v-row>
        <v-col cols="12" md="3">
          <FormDatePicker v-model="filtro.dataInicio" label="Data inicial" clearable />
        </v-col>
        <v-col cols="12" md="3">
          <FormDatePicker v-model="filtro.dataFim" label="Data final" clearable />
        </v-col>
        <v-col cols="12" md="3">
          <FormField v-model="filtro.produto" label="Produto" clearable placeholder="Nome do produto" />
        </v-col>
        <v-col cols="12" md="3">
          <FormField v-model="filtro.numpedido" label="Número do pedido" clearable placeholder="Somente números" />
        </v-col>
        <v-col cols="12" md="4">
          <FormSelect v-model="filtro.canal" label="Canal" :options="opcoesCanal" />
        </v-col>
        <v-col cols="12" md="auto" class="mt-1">
          <FormButton type="submissao" text="Buscar" id="btn-buscar-assistente" :loading="carregando"
            @click="aplicarFiltro" />
        </v-col>
      </v-row>
    </Panel>

    <Panel lineColor="var(--primary-color)" class="assistente-panel" id="card-resultado-consulta">
      <div v-if="carregando && !itens.length" class="assistente-loading">
        <v-progress-circular indeterminate color="primary" />
      </div>

      <template v-else>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-center">Pedido</th>
              <th class="text-left">Produto</th>
              <th class="text-center">Canal</th>
              <th class="text-left">Data</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!erroApi && !itens.length">
              <td colspan="4" class="assistente-vazio">
                Nenhuma venda do assistente neste filtro.
              </td>
            </tr>
            <tr v-for="item in itens" :key="chaveItem(item)">
              <td>
                <Chip
                  small
                  dense
                  rounded
                  color="grey"
                  :text="String(item.numpedido)"
                />
              </td>
              <td class="text-left">{{ nomeProduto(item) }}</td>
              <td>
                <Chip
                  small
                  dense
                  rounded
                  outlined
                  :color="corCanal(item.canal)"
                  :text="rotuloCanal(item.canal)"
                />
              </td>
              <td class="text-left">{{ formatarData(item.datapedido) }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="consulta-rodape">
          <div class="consulta-rodape__por-pagina">
            <span>Itens por página:</span>
            <v-menu offset-y v-model="selectorPageOpen">
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" :class="{ open: selectorPageOpen }">
                  <span class="consulta-rodape__limite">{{ limit }}</span>
                  <v-icon class="consulta-rodape__caret">fas fa-caret-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="n in limitesPagina"
                  :key="n"
                  @click="selecionarLimite(n)"
                >
                  {{ n }}
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="consulta-rodape__indice">
            Exibindo {{ inicioExibicao }} a {{ fimExibicao }} de
            {{ total }} registros
          </div>
          <div class="consulta-rodape__setas">
            <v-btn
              text
              :disabled="carregando || page <= 1"
              @click="irPara(page - 1)"
            >
              <v-icon size="24">fas fa-chevron-left</v-icon>
            </v-btn>
            <v-btn
              text
              :disabled="carregando || total <= 0 || page >= totalPaginas"
              @click="irPara(page + 1)"
            >
              <v-icon size="24">fas fa-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </template>

      <div v-if="erroApi" class="assistente-status-alteracoes">
        <v-icon size="14" color="error">fas fa-exclamation-circle</v-icon>
        <span class="texto-erro">{{ erroApi }}</span>
      </div>
    </Panel>
  </div>
</template>

<script>
import FormButton from "@/components/form/FormButton";
import FormDatePicker from "@/components/form/FormDatePicker";
import FormField from "@/components/form/FormField";
import FormSelect from "@/components/form/FormSelect";
import Panel from "@/components/Panel";
import Chip from "@/components/Chip";
import moment from "moment";
import { ASSISTENTE_RECOMENDACAO_LISTAR } from "@/store/actions/assistente-recomendacao";
import { mensagemErroApi } from "./assistente-recomendacao-form";
import {
  LIMITE_CONSULTA,
  consultaParaQuery
} from "./assistente-recomendacao-consulta";

export default {
  name: "AssistenteRecomendacaoConsulta",
  components: {
    FormButton,
    FormDatePicker,
    FormField,
    FormSelect,
    Panel,
    Chip
  },
  data() {
    return {
      carregando: false,
      erroApi: "",
      itens: [],
      total: 0,
      page: 1,
      limit: LIMITE_CONSULTA,
      selectorPageOpen: false,
      limitesPagina: [5, 10, 15, 20, 30],
      filtro: {
        dataInicio: "",
        dataFim: "",
        produto: "",
        numpedido: "",
        canal: ""
      },
      opcoesCanal: [
        { text: "Todos", value: "" },
        { text: "Assistente de Compras", value: "COMPRAS" },
        { text: "Assistente de Vendas", value: "VENDAS" }
      ]
    };
  },
  computed: {
    totalPaginas() {
      if (!this.total || !this.limit) {
        return 0;
      }
      return Math.ceil(this.total / this.limit);
    },
    inicioExibicao() {
      if (!this.total || !this.itens.length) {
        return 0;
      }
      return (this.page - 1) * this.limit + 1;
    },
    fimExibicao() {
      if (!this.total || !this.itens.length) {
        return 0;
      }
      return (this.page - 1) * this.limit + this.itens.length;
    }
  },
  created() {
    this.buscar(1);
  },
  methods: {
    aplicarFiltro() {
      this.buscar(1);
    },
    irPara(pagina) {
      if (pagina < 1 || (this.totalPaginas && pagina > this.totalPaginas)) {
        return;
      }
      this.buscar(pagina);
    },
    selecionarLimite(limite) {
      this.selectorPageOpen = false;
      if (limite === this.limit) {
        return;
      }
      this.limit = limite;
      this.buscar(1);
    },
    buscar(pagina) {
      this.carregando = true;
      this.erroApi = "";
      this.$store
        .dispatch(
          ASSISTENTE_RECOMENDACAO_LISTAR,
          consultaParaQuery(this.filtro, pagina, this.limit)
        )
        .then(lista => {
          const corpo = lista || {};
          this.itens = Array.isArray(corpo.itens) ? corpo.itens : [];
          this.total = Number(corpo.total) || 0;
          this.limit = Number(corpo.limit) || LIMITE_CONSULTA;
          this.page = Number(corpo.page) || pagina;
          this.carregando = false;
        })
        .catch(err => {
          this.carregando = false;
          this.erroApi = mensagemErroApi(err);
        });
    },
    chaveItem(item) {
      return [
        item.numpedido,
        item.idcadastroextraproduto,
        item.canal
      ].join("-");
    },
    nomeProduto(item) {
      const nome = item && item.nome != null ? String(item.nome).trim() : "";
      return nome || "—";
    },
    rotuloCanal(canal) {
      if (canal === "COMPRAS") {
        return "Assistente de Compras";
      }
      if (canal === "VENDAS") {
        return "Assistente de Vendas";
      }
      return canal || "—";
    },
    corCanal(canal) {
      if (canal === "COMPRAS") {
        return "green";
      }
      if (canal === "VENDAS") {
        return "orange";
      }
      return "grey";
    },
    formatarData(valor) {
      if (!valor) {
        return "—";
      }
      const data = moment(valor);
      return data.isValid() ? data.format("DD/MM/YYYY HH:mm") : "—";
    }
  }
};
</script>

<style scoped>
.nota-informativa {
  background: #f5f7fa;
  border-left: 3px solid var(--primary-color);
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 20px;
  color: #6a6c6f;
  text-align: left;
}

.nota-informativa .v-icon {
  margin-right: 8px;
}

.assistente-panel {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.section-title,
.section-subtitle {
  text-align: left;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.section-subtitle {
  color: #6a6c6f;
  font-size: 16px;
  margin-bottom: 16px;
}

.assistente-loading {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.assistente-vazio {
  color: #6a6c6f;
  text-align: left;
  padding: 16px 0;
}

.assistente-status-alteracoes {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  text-align: left;
}

.texto-erro {
  color: var(--danger-color);
  font-weight: 600;
}

.consulta-rodape {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  font-size: 12px;
  line-height: 1;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding: 4px 8px;
  text-align: left;
}

.consulta-rodape__por-pagina,
.consulta-rodape__setas {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.consulta-rodape__limite {
  margin-right: 10px;
}

.consulta-rodape__caret {
  transition: transform 0.3s ease-in-out;
}

.consulta-rodape__por-pagina .open .consulta-rodape__caret {
  transform: rotate(180deg);
}

.consulta-rodape__indice {
  padding: 0 15px;
  white-space: nowrap;
}

.consulta-rodape__setas ::v-deep .v-btn {
  width: 50px;
  min-width: 0;
  height: auto;
  padding: 5px;
}

.consulta-rodape__setas ::v-deep .v-btn + .v-btn {
  margin-left: 5px;
}

.consulta-rodape__por-pagina ::v-deep .v-btn {
  min-width: 0;
  height: auto;
  padding: 5px;
}
</style>
